module.exports = __webpack_public_path__ + "static/media/logo-beneser-front.27e167f5.svg";